import { useState, useEffect } from "react";

export default function useGeolocation() {
  const [location, setLocation] = useState(() => {
    const saved = localStorage.getItem("user_location");
    return saved ? JSON.parse(saved) : null;
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 🔇 GEOLOCATION DISABLED
    // Automatically request geolocation is disabled
    setLoading(false);
    
    // if (!navigator.geolocation) {
    //   setError("Geolocation not supported");
    //   setLoading(false);
    //   return;
    // }

    // navigator.geolocation.getCurrentPosition(
    //   async (position) => {
    //     const { latitude, longitude } = position.coords;

    //     // Reverse geocode
    //     const address = await reverseGeocode(latitude, longitude);

    //     const fullLocation = {
    //       lat: latitude,
    //       lon: longitude,
    //       city: address.city,
    //       state: address.state,
    //       country: address.country,
    //       full_address: address.full_address,
    //       timestamp: Date.now(),
    //     };

    //     // Save everywhere
    //     setLocation(fullLocation);
    //     localStorage.setItem("user_location", JSON.stringify(fullLocation));

    //     setLoading(false);
    //   },
    //   (err) => {
    //     setError(err.message);
    //     setLoading(false);
    //   },
    //   { enableHighAccuracy: true }
    // );
  }, []);

  return { location, error, loading };
}

// -----------------------------------------
// 📌 Reverse Geocode Using Nominatim API
// -----------------------------------------
async function reverseGeocode(lat, lon) {
  try {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`;

    const res = await fetch(url, {
      headers: {
        "User-Agent": "YourAppName/1.0",
      },
    });

    const data = await res.json();

    return {
      city: data.address.city || data.address.town || data.address.village || "",
      state: data.address.state || "",
      country: data.address.country || "",
      full_address: data.display_name,
    };
  } catch (error) {
    // console.log("Reverse geocoding error:", error);
    return {
      city: "",
      state: "",
      country: "",
      full_address: "",
    };
  }
}
